<dx-popup [title]="'remotePlatforms.lblAzureStorageAccount' | translate" [(visible)]="visible" (onShown)="onShown()" (onHidden)="onHidden()">
    <div *dxTemplate="let data of 'content'">
        <dx-progress-bar width="100%"
                         [height]="15"
                         [value]="false"
                         [visible]="isProgressBarVisible" />
        <dx-scroll-view>
            <dx-validation-group #remotePlatformValidation>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.information</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>remotePlatforms.lblDisabled</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="platform.isDisabled" [(readOnly)]="readOnly"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblName<span class="dx-field-item-required-mark" *ngIf="!readOnly"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.name" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'remotePlatforms.msgNameRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblAccountName<span class="dx-field-item-required-mark" *ngIf="!readOnly"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.accountName" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'remotePlatforms.msgAccountNameRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblEndpointSuffix<span class="dx-field-item-required-mark" *ngIf="!readOnly"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.endpointSuffix" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'remotePlatforms.msgEndpointSuffixRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblServiceType<span class="dx-field-item-required-mark" *ngIf="!readOnly"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <app-azure-service-type-picker [(readOnly)]="readOnly" [(selectedItem)]="platform.serviceType" (selectedItemChange)="onServiceChanged($event)"></app-azure-service-type-picker>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.security</div>
                    <div class="dx-field" *ngIf="readOnly">
                        <div class="dx-field-label" translate>remotePlatforms.lblAuthentication</div>
                        <div class="dx-field-value">
                            <dx-text-box [readOnly]="true" [value]="getAuthenticationModeLabel()"></dx-text-box>
                            <span *ngIf="platform.useAgentsEntraIdentity" class="agentsCompatibilityWarning" translate>remotePlatforms.msgOnlyAvailableWithAgentsv23x</span>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>remotePlatforms.lblIpFiltering</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="platform.ipFiltering" [(readOnly)]="readOnly"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="!readOnly && platform.serviceType === 1">
                        <div class="dx-field-label" translate>remotePlatforms.lblUseAgentsEntraIdentity</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="platform.useAgentsEntraIdentity" [(readOnly)]="readOnly"></dx-switch>
                            <span *ngIf="platform.useAgentsEntraIdentity && !readOnly" class="agentsCompatibilityWarning" translate>remotePlatforms.msgOnlyAvailableWithAgentsv23x</span>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="!platform.useAgentsEntraIdentity && !readOnly">
                        <div class="dx-field-label" translate>remotePlatforms.lblAccessKey</div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.accessKey" mode="password" [placeholder]="getAccessKeyPlaceHolder()" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="custom" [reevaluate]="true" [validationCallback]="validateCredentials" [message]="'remotePlatforms.msgAccessKeyOrSasTokenRequired' | translate" />
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="!platform.useAgentsEntraIdentity && !readOnly">
                        <div class="dx-field-label" translate>remotePlatforms.lblSasToken</div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.sasToken" mode="password" [placeholder]="getSasTokenPlaceHolder()" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="custom" [reevaluate]="true" [validationCallback]="validateCredentials" [message]="'remotePlatforms.msgAccessKeyOrSasTokenRequired' | translate" />
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
        <div class="flex bottom-buttons leftButtons" *ngIf="!readOnly">
            <dx-button *ngIf="!readOnly" class="save leftButton" [text]="'_commons.save' | translate" (onClick)="save()"></dx-button>
            <dx-button class="cancel leftButton" [text]="'_commons.cancel' | translate" (onClick)="this.visible = false"></dx-button>
        </div>
        <div class="flex bottom-buttons" *ngIf="readOnly">
            <dx-button class="close closeButton" [text]="'_commons.close' | translate" (onClick)="this.visible = false"></dx-button>
        </div>
    </div>
</dx-popup>